<button class="ace-btn btn-secondary has-icon"
        (click)="openOverridesModal()"
        helpTooltip
        helpContentId="return-preview-form-overrides.show-all-overrides"
        position="bottom">
    <i class="fa fa-search-plus"></i>
</button>
